module.exports = __webpack_public_path__ + "media/images/home/main/aa/backup/12-b5d6081a07a1ccb7f706870b687bf6ce.png";